import React, { useContext } from "react";
import { Typography } from "@material-ui/core";
import { RequestContext } from "../../context/RequestContext";
import { DashboardContext } from "../../context/DashboardContext";
import { UserContext } from "../../context/UserContext";
import DashboardMode from "../../constants/DashboardMode";
import { MEDIA_SEARCH } from "../../constants/MediaSearch";
import { UserRoles } from "../../constants/UserRoles";
import _ from "lodash";
import "../../styles/dashboard.scss";
import { CONTENT_FINDER } from "../../constants/ContentFinder";

const Header = ({mode, headingText}) => {
  const { requestId, loading, status } = useContext(RequestContext);
  const { dashboardView } = useContext(DashboardContext);
  const { userRole } = useContext(UserContext);

  return mode === "dashboard" ? (
    <Typography className="dashboardHeader">
      {_.startCase(dashboardView === DashboardMode.JOBS ? "Job" : userRole === UserRoles.MEDIAREQUEST ? "Media Request" : "Request") + " " + headingText}
    </Typography>
  ) : mode === "Request Summary" ? (
    <Typography className="dashboardHeader">
      {headingText}
    </Typography>
  ) : _.isEmpty(requestId) && !loading ? (
    <Typography className="dashboardHeader">
      {headingText}
    </Typography>
  ) : !_.isEmpty(requestId) ? (
    <Typography className="dashboardHeader">Status : {status}</Typography>
  ) : <Typography className= {headingText === MEDIA_SEARCH.dashboardHeader || headingText === CONTENT_FINDER.dashboardHeader ? "mediaRequestDashboardHeader" : "dashboardHeader"}>
    {headingText}
  </Typography>
};

Header.defaultProps = {
  mode: "dashboard",
  headingText: "",
};

export default Header;
